import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.editorial',
    },
};

class Editorial {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._scroll = true;
    }

    init() {
        // console.log('init scroll behaviour');
        if(navigator.userAgent.indexOf('Firefox') != -1) {
            $('body').addClass("firefox")
          }
      
        const target = this._$rootElement.find('.editorial__side-stories')[0];

        // document.addEventListener('wheel', (e) => {
        //     if(!Breakpoints.isBreakpointOrLarger('md')) return;

        //     if(e.deltaY > 0) {
        //         // scrolling down
        //         if(this._viewPortBottomCloseElementBottom()) {
        //             if(!this._scroll && Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1) {
        //                 Scrolling.removeBodyNoScroll();
        //                 Navigation.canChangeScrollBehavior = true;
        //                 this._scroll = true;
        //             } else if (this._scroll && !(Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1)){
        //                 Scrolling.addBodyNoScroll();
        //                 Navigation.canChangeScrollBehavior = false;
        //                 this._scroll = false;                    
        //             }
        //         }
        //     } else {
        //         // scrolling up
        //         if(this._viewPortTopCloseElementTop()) {
        //             if(!this._scroll && target.scrollTop === 0) {
        //                 Scrolling.removeBodyNoScroll();
        //                 Navigation.canChangeScrollBehavior = true;
        //                 this._scroll = true;
        //             } else if(this._scroll && target.scrollTop !== 0) {
        //                 Scrolling.addBodyNoScroll();
        //                 Navigation.canChangeScrollBehavior = false;
        //                 this._scroll = false;  
        //             }
        //         }
        //     }


        //     if(!this._scroll) {
        //         target.scrollBy(e.deltaX, e.deltaY);

        //         if (e.deltaY > 0 && Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1) {
        //             Scrolling.removeBodyNoScroll();
        //             Navigation.canChangeScrollBehavior = true;
        //             // enableScroll();
        //             this._scroll = true;
        //         } else if (e.deltaY < 0 && target.scrollTop === 0) {
        //             Scrolling.removeBodyNoScroll();
        //             Navigation.canChangeScrollBehavior = true;
        //             // enableScroll();
        //             this._scroll = true;
        //         }
        //     }
        // });
    }

    _scrollRightSide() {
        const elementTop = this._$rootElement.position().top;
        const elementBottom = elementTop + this._$rootElement.height();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return viewportBottom >= elementBottom + 100;
    }

    _viewPortBottomCloseElementBottom() {
        const elementTop = this._$rootElement.position().top;
        const elementBottom = elementTop + this._$rootElement.height();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return viewportBottom >= elementBottom + 100; 
    }

    _viewPortTopCloseElementTop() {
        const elementTop = this._$rootElement.position().top;
        const viewportTop = $(window).scrollTop();

        return viewportTop <= elementTop; 
    }

    _isMdOrHigher() {
        return Breakpoints.isBreakpointOrLarger('md');
    }
}

moduleRegistry.registerModule('Editorial', Editorial);
moduleRegistry.autoApplyModule('Editorial', config.selectors.root);
